module.exports = __webpack_public_path__ + "img/5.68fe7079.png";